<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseSelect } from "@/components";

export default {
  name: "DataFilter",
  components: {
    BaseSelect,
  },
  data() {
    return {
      applications: [],
      status: [],
      platform: [],
      customerId: 0,
    };
  },
  mounted() {
    this.setFilter({});
    this.customerId = this.$route.params.customerId;
    this.getFilter();
  },
  computed: {
    ...mapGetters(["getFilterList", "getFilterData", "generalFilter"]),
  },
  methods: {
    ...mapActions(["fillFilter", "getAllPackages"]),
    ...mapMutations(["setFilter", "setGeneralFilter"]),
    getFilter() {
      this.fillFilter().then((res) => {
        if (res.data) {
          const applicationsList = this.getFilterList.filter(
            (o) => o.name === "Applications"
          );

          if (applicationsList.length > 0)
            this.applications = applicationsList[0].values;

          const statusList = this.getFilterList.filter(
            (o) => o.name === "Status"
          );

          if (statusList.length > 0) this.status = statusList[0].values;

          const platformList = this.getFilterList.filter(
            (o) => o.name === "Platforms"
          );

          if (platformList.length > 0) this.platform = platformList[0].values;
        }
      });
    },
    changeStatus(value) {
      if (value) {
        this.setGeneralFilter({
          page: 1,
          size: 100,
          filter: { Status: value?.code.toString() },
        });
      } else {
        delete this.generalFilter.filter.Status;
        this.setGeneralFilter({ filter: this.getFilterData });
      }
      this.getAllPackages(this.customerId);
    },
    changeApplication(value) {
      if (value) {
        this.setGeneralFilter({
          page: 1,
          size: 100,
          filter: { Applications: value?.code.toString() },
        });
      } else {
        delete this.generalFilter.filter.Applications;
        this.setGeneralFilter({ filter: this.getFilterData });
      }
      this.getAllPackages(this.customerId);
    },
    changePlatform(value) {
      if (value) {
        this.setGeneralFilter({
          page: 1,
          size: 100,
          filter: { Platforms: value?.code.toString() },
        });
      } else {
        delete this.generalFilter.filter.Platforms;
        this.setGeneralFilter({ filter: this.getFilterData });
      }
      this.getAllPackages(this.customerId);
    },
  },
};
</script>
<template>
  <div class="filter">
    <base-select
      fieldLabel="İşlem Platformu"
      placeholder="İşlem Platformu Seç"
      :options="applications"
      id="vendor"
      @change="changeApplication"
      :clearable="true"
    />
    <base-select
      fieldLabel="Paket Durumu Seç"
      placeholder="Paket Durumu Seç"
      :options="status"
      id="filter"
      @change="changeStatus"
      :clearable="true"
    />
    <base-select
      fieldLabel="İşlem Yeri"
      placeholder="İşlem Yeri Seç"
      :options="platform"
      id="platform"
      @change="changePlatform"
      :clearable="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
@media screen and (max-width: 889px) {
  .filter {
    display: block;
    width: 100%;
  }
}
.form-group:not(:last-child) {
  margin-right: 1px;
}
.form-control-label {
  font-size: 12px;
  color: var(--grayscale-70);
}
</style>
<style lang="scss">
.filter {
  .form-control-label {
    font-size: 12px;
    color: var(--grayscale-70);
    position: relative;
    padding: 0 7px;
    margin-left: 10px;
    z-index: 2;
    top: 10px;
  }
}
</style>

<style lang="scss">
.filter {
  .veri-dagitim-selectbox.v-select {
    background: white !important;

    .vs {
      &__dropdown-toggle {
        background: white !important;
      }
    }
  }
}
</style>
